import * as service from './service'
import { HTTP_CODE } from '@/utils/request'

export default {
  namespace: 'shansongValueExplainInfo',
  state: {
    demoData: {}
  },
  effects: {
    * getExplainInfo ({ payload }, { call, put }) {
      const res = yield call(service.getExplainInfo, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
